import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ISaleOrder } from '../../../models/sale-order.interface';

@Component({
    selector: 'eci-sale-order-pnl',
    templateUrl: './sale-order-pnl.component.html',
    styleUrls: ['./sale-order-pnl.component.scss']
})
export class SaleOrderPnlComponent {

    @Input() info: ISaleOrder | null = null;

    form: FormGroup;

    constructor(private fb: FormBuilder) {
        this.form = this.fb.group({
            totalLastMileCost: [''],
            totalLmAddCharges: [''],
            lastMileGrandTotal: [''],
            totalCost: [''],
            totalProfit: [''],
            averageProfitPerOrder: [''],
        });
    }
}
